let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("L9vws")).then(() => parcelRequire('aQatf'));